import apiClient from '../../../components/api/apiClient';

/** Same host as workflow run logs (see REACT_APP_API_URL_workflow_run_logs in .env.example). */
export function resolveWorkflowRunServiceBaseUrl(): string {
  const raw = (process.env.REACT_APP_API_URL_workflow_run_logs ?? '').trim();
  return raw.replace(/\/+$/, '');
}

export function workflowRunStartErrorMessage(err: unknown): string {
  if (err instanceof Error && err.message) return err.message;
  if (err && typeof err === 'object' && 'response' in err) {
    const resp = (err as { response?: { data?: unknown; status?: number } }).response;
    const d = resp?.data;
    if (typeof d === 'string' && d.trim()) return d.trim();
    if (d && typeof d === 'object') {
      const o = d as Record<string, unknown>;
      const m = o.message ?? o.title ?? o.detail ?? o.error;
      if (typeof m === 'string' && m.trim()) return m.trim();
    }
    if (resp?.status != null) return `Could not start run (HTTP ${resp.status}).`;
  }
  return 'Could not start run.';
}

export async function postWorkflowRunStart(
  workflowId: string,
  input: Record<string, unknown>
): Promise<unknown> {
  const base = resolveWorkflowRunServiceBaseUrl();
  if (!base) {
    throw new Error(
      'Missing REACT_APP_API_URL_workflow_run_logs. Add it to your environment (see .env.example), then restart the dev server.'
    );
  }
  console.log('base', base);
  console.log('workflowId', workflowId);
  console.log('input', input);
  const { data } = await apiClient.post<unknown>(
    '/runs/start',
    { workflowId: workflowId.trim(), input },
    {
      baseURL: base,
      headers: {
        Accept: 'text/plain, application/json',
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
}
